

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { bacSlideOverService } from 'bac-frontend-common'
import Photo from '@/components/photo.vue'
import { Getter } from 'vuex-class'

@Component({
  components: {
    Photo
  }
})
export default class ComposeComment extends Vue {
  validation: boolean = false

  openSlideOver () {
    bacSlideOverService.openSlideOver({
      component: Photo,
      data: { img: 'test' }
    })
  }

  addComment () {
    if (this.composeCommentStore.text === '' && this.composeCommentStore.img === '') {
      this.validation = true
    } else {
      this.$store.dispatch('saveComment').then(() => {
        this.composeCommentStore.reset()
      })
      this.validation = false
      bacSlideOverService.closeCurrentSlideOver()
    }
  }

  @Getter('composeComment') composeCommentStore : any

}
